import { render, staticRenderFns } from "./MergeForm.vue?vue&type=template&id=51521a3c&"
import script from "./MergeForm.vue?vue&type=script&lang=js&"
export * from "./MergeForm.vue?vue&type=script&lang=js&"
import style0 from "./MergeForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports